import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';

@Component({
	selector: 'portals-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.scss'],
	animations: [
		trigger('dropdownAnimation', [
			state(
				'hidden',
				style({
					height: '0',
					overflow: 'hidden',
				})
			),
			state(
				'visible',
				style({
					height: '*',
				})
			),
			transition('hidden <=> visible', [animate('1s ease-in-out')]), // Transition between hidden and visible states
		]),
	],
})
export class NavbarComponent implements OnInit {
	navbarOpen = false;

	navigateToHome() {
		this.router.navigate(['/']);
	}
	navigateToFAQ() {
		this.router.navigate(['/faq']);
	}
	navigateToCompany() {
		this.router.navigate(['/company']);
	}
	navigateToSupport() {
		this.router.navigate(['/support']);
	}
	navigateToPricing() {
		this.router.navigate(['/pricing']);
	}
	toggleNavbar() {
		this.navbarOpen = !this.navbarOpen;
	}

	constructor(private router: Router) {}

	ngOnInit(): void {}
}
